import { render, staticRenderFns } from "./OCC.vue?vue&type=template&id=66c63ea4&scoped=true&"
import script from "./OCC.vue?vue&type=script&lang=js&"
export * from "./OCC.vue?vue&type=script&lang=js&"
import style0 from "./OCC.vue?vue&type=style&index=0&id=66c63ea4&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c63ea4",
  null
  
)

export default component.exports